import React from 'react';
import { Link } from 'react-router-dom';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import styles from './PostFooter.module.scss';

const PostFooter = ({ step = '', usersCount = '200,000', onShowExplainer }) => (
  <div>
    <div>
      <hr style={{ maxWidth: '600px' }} />
      <div className={styles.footerTermsText}>
        If you'd rather speak to someone,{' '}
        <a
          className="contact-support"
          href="https://www.twine.net/contact"
          title="Speak to the team"
        >
          message us{' '}
          <SvgIcon
            icon="bubble"
            size="14"
            style={{ marginLeft: '2px', paddingTop: '2px' }}
          />
        </a>
      </div>
      <div className={styles.footerTermsText}>
        By posting a project, you agree to our{' '}
        <a href="/platform-terms" target="_blank" title="Platform Terms">
          Terms
        </a>
        .
      </div>
    </div>
    {step === 'roleStep' && (
      <div className={styles.container}>
        <Grid>
          <Row>
            <Col xs={12} sm={4} className={styles.column}>
              {step === 'roleStep' && (
                <>
                  <p className={styles.header} key="trust_1">
                    <Link
                      to="/enterprise"
                      target="_blank"
                      className={styles.header}
                    >
                      For Business
                    </Link>
                  </p>
                  <p className="fs-14" key="trust_2">
                    Get expert help with writing job briefs, shortlisting and
                    managing communication with freelancers or even build teams
                    of expert freelancers.
                  </p>
                  <Link to="/enterprise" target="_blank" key="trust_3">
                    Learn about Twine Business {'>'}
                  </Link>
                </>
              )}
              {step === 'payment' && (
                <>
                  <p className={styles.header} key="payment_1">
                    Trusted payment with Twine:
                  </p>
                  <ul key="payment_2">
                    <li className={styles.tick}>
                      Send payment <strong>safely</strong> and{' '}
                      <strong>securely</strong> through Twine
                    </li>
                    <li className={styles.tick}>
                      Hire with <strong>confidence</strong>
                    </li>
                  </ul>
                </>
              )}
            </Col>
            <Col xs={12} sm={4} className={[styles.column, styles.middle]}>
              <p className={styles.header}>Hire trusted freelancers:</p>
              <ul>
                <li className={styles.tick}>
                  Post your project for <strong>free</strong>
                </li>
                <li className={styles.tick}>
                  Protected by our <strong>money back guarantee</strong>
                </li>
                <li className={styles.tick}>
                  Search from <strong>{usersCount}</strong> freelancers
                </li>
              </ul>
            </Col>
            <Col xs={12} sm={4} className={styles.column}>
              <p className={styles.header}>Need help?</p>
              <ul>
                <li className={styles.dot}>
                  <a
                    href="https://help.twine.net/en/article/getting-started-guide-for-clients-15bzh87/"
                    target="_blank"
                    title="Client help center"
                    rel="noreferrer"
                  >
                    Your quick guide to using Twine{' '}
                    <SvgIcon
                      icon="help"
                      size="12"
                      style={{ marginLeft: '2px', paddingTop: '2px' }}
                    />
                  </a>
                </li>
                <li className={styles.dot}>
                  <a
                    onClick={onShowExplainer}
                    className="pointer"
                    title="See how Twine works"
                  >
                    See how Twine works{' '}
                    <SvgIcon
                      icon="play_circle"
                      size="12"
                      style={{ marginLeft: '2px', paddingTop: '2px' }}
                    />
                  </a>
                </li>
                <li className={styles.dot}>
                  <a
                    className="contact-support"
                    href="https://www.twine.net/contact"
                    target="_blank"
                    title="Contact us"
                    rel="noreferrer"
                  >
                    Contact the Twine team{' '}
                    <SvgIcon
                      icon="bubble"
                      size="12"
                      style={{ marginLeft: '2px', paddingTop: '2px' }}
                    />
                  </a>
                </li>
              </ul>
            </Col>
          </Row>
        </Grid>
      </div>
    )}
  </div>
);

export default PostFooter;
